import { render, staticRenderFns } from "./devTypeList.vue?vue&type=template&id=5010f0e2"
import script from "./devTypeList.vue?vue&type=script&lang=js"
export * from "./devTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports